<!--forgot password container-->
@if (formGroup) {
  <div class="auth-container p-2" [formGroup]="formGroup">
    <div class="login-box">
      <div class="surface-card p-4 shadow-2 border-round-2xl w-full">

        <div class="flex justify-content-center mb-5">
        <span class="w-6rem h-6rem border-circle flex justify-content-center align-items-center bg-orange-50">
          <i class="pi pi-lock text-orange-600 text-5xl"></i>
        </span>
        </div>

        <div class="text-center mb-6">
          <div class="text-color text-3xl font-semibold mb-2">Passwort vergessen</div>
          <span class="text-600 font-medium line-height-3 text-color-secondary">Bitte gib deine E-Mail-Adresse oder Kundennummer ein.</span>
        </div>

        <div class="mb-4">
<!--          <label for="emailForget" class="block text-900 font-medium mb-2">E-Mail / Kundennummer / Telefonnummer</label>-->
          <input id="emailForget" formControlName="anyUserText" type="text" placeholder="E-Mail oder Kundenummer"
                 pInputText class="w-full">
        </div>

        <p-message *ngIf="formGroup?.get('anyUserText')?.errors" severity="error" [text]="formGroup.get('anyUserText')?.errors?.['notFound']"
                   [ngStyle]="{'word-break': 'break-word'}"
                   styleClass="block text-left"></p-message>

<!--        <button pButton pRipple label="Sicherheitscode senden" class="w-full my-4"-->
<!--                (click)="handleForgotPassword()"></button>-->

        <app-button [busy]="busy"
                    [label]="'Sicherheitscode senden'"
                    [class]="'w-full my-4'"
                    (onClick)="handleForgotPassword()">
        </app-button>

        <div class="flex flex-column mt-3 gap-2 text-center">
          <span class="text-color-secondary">Bist du bereits Klaus Kunde? </span>
          <span class="text-primary font-medium cursor-pointer" (click)="navigateToLogin()">Anmelden</span>
        </div>

      </div>
    </div>


  </div>

  <p-dialog [(visible)]="visible" [modal]="true" [header]="forgotPasswordDto?.label"
            styleClass="md:width-40rem custom-header-padding">
    <div class="mb-5  md:mt-0 mt-3">
      <p class="text-sm mt-1">{{ forgotPasswordDto?.description }}</p>
    </div>
    <div class="flex flex-column gap-3">

      @if (forgotPasswordDto && forgotPasswordDto.options) {
        @for (option of forgotPasswordDto.options;track option) {
          <div class="flex align-items-center p-3 border-1 border-200 border-round" [class.bg-primary-50]="option.type == selectedOption">
            <p-radioButton [(ngModel)]="selectedOption" [name]="option.label" [value]="option.type"
                           [inputId]="option.label"></p-radioButton>
            <label class="ml-2"> {{ option.label }} <span
              class="text-900 font-semibold">{{ option.value }}</span></label>
          </div>
        }
      }

    </div>
    <div class="text-center mt-3">
<!--      <button pButton pRipple label="Sicherheitscode senden" (click)="handleRequestOtp()" class="mt-5"></button>-->

        <app-button [busy]="busy"
                    [label]="'Sicherheitscode senden'"
                    [class]="'mt-5'"
                    [showIcon]="false"
                    [disabled]="selectedOption != ForgotPasswordOptionEnum.email && this.selectedOption != ForgotPasswordOptionEnum.phone"
                    (onClick)="handleRequestOtp()">
        </app-button>

    </div>
  </p-dialog>
}
